import { __extends as k, __assign as g } from "./index11.js";
import { v4 as U } from "./index44.js";
import u from "./index47.js";
import { tld as A } from "./index48.js";
import j from "./index18.js";
var f = {
  persist: !0,
  cookie: {
    key: "ajs_user_id",
    oldKey: "ajs_user"
  },
  localStorage: {
    key: "ajs_user_traits"
  }
}, K = (
  /** @class */
  function() {
    function o() {
      this.cache = {};
    }
    return o.prototype.get = function(e) {
      return this.cache[e];
    }, o.prototype.set = function(e, r) {
      this.cache[e] = r;
    }, o.prototype.remove = function(e) {
      delete this.cache[e];
    }, Object.defineProperty(o.prototype, "type", {
      get: function() {
        return "memory";
      },
      enumerable: !1,
      configurable: !0
    }), o;
  }()
), x = 365, _ = (
  /** @class */
  function(o) {
    k(e, o);
    function e(r) {
      r === void 0 && (r = e.defaults);
      var t = o.call(this) || this;
      return t.options = g(g({}, e.defaults), r), t;
    }
    return e.available = function() {
      var r = window.navigator.cookieEnabled;
      return r || (u.set("ajs:cookies", "test"), r = document.cookie.includes("ajs:cookies"), u.remove("ajs:cookies")), r;
    }, Object.defineProperty(e, "defaults", {
      get: function() {
        return {
          maxage: x,
          domain: A(window.location.href),
          path: "/",
          sameSite: "Lax"
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.opts = function() {
      return {
        sameSite: this.options.sameSite,
        expires: this.options.maxage,
        domain: this.options.domain,
        path: this.options.path,
        secure: this.options.secure
      };
    }, e.prototype.get = function(r) {
      try {
        var t = u.get(r);
        if (!t)
          return null;
        try {
          return JSON.parse(t);
        } catch {
          return t;
        }
      } catch {
        return null;
      }
    }, e.prototype.set = function(r, t) {
      typeof t == "string" ? u.set(r, t, this.opts()) : t === null ? u.remove(r, this.opts()) : u.set(r, JSON.stringify(t), this.opts());
    }, e.prototype.remove = function(r) {
      return u.remove(r, this.opts());
    }, Object.defineProperty(e.prototype, "type", {
      get: function() {
        return "cookie";
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(K)
), m = function(o, e) {
  console.warn("Unable to access ".concat(o, ", localStorage may be ").concat(e));
}, O = (
  /** @class */
  function(o) {
    k(e, o);
    function e() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return e.available = function() {
      var r = "test";
      try {
        return localStorage.setItem(r, r), localStorage.removeItem(r), !0;
      } catch {
        return !1;
      }
    }, e.prototype.get = function(r) {
      try {
        var t = localStorage.getItem(r);
        if (t === null)
          return null;
        try {
          return JSON.parse(t);
        } catch {
          return t;
        }
      } catch {
        return m(r, "unavailable"), null;
      }
    }, e.prototype.set = function(r, t) {
      try {
        localStorage.setItem(r, JSON.stringify(t));
      } catch {
        m(r, "full");
      }
    }, e.prototype.remove = function(r) {
      try {
        return localStorage.removeItem(r);
      } catch {
        m(r, "unavailable");
      }
    }, Object.defineProperty(e.prototype, "type", {
      get: function() {
        return "localStorage";
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(K)
), b = (
  /** @class */
  function() {
    function o(e, r) {
      this.storageOptions = r, this.enabledStores = e;
    }
    return o.prototype.getStores = function(e) {
      var r = this, t = [];
      return this.enabledStores.filter(function(n) {
        return !e || e?.includes(n);
      }).forEach(function(n) {
        var a = r.storageOptions[n];
        a !== void 0 && t.push(a);
      }), t;
    }, o.prototype.getAndSync = function(e, r) {
      var t = this.get(e, r), n = typeof t == "number" ? t.toString() : t;
      return this.set(e, n, r), n;
    }, o.prototype.get = function(e, r) {
      for (var t = null, n = 0, a = this.getStores(r); n < a.length; n++) {
        var s = a[n];
        if (t = s.get(e), t)
          return t;
      }
      return null;
    }, o.prototype.set = function(e, r, t) {
      for (var n = 0, a = this.getStores(t); n < a.length; n++) {
        var s = a[n];
        s.set(e, r);
      }
    }, o.prototype.clear = function(e, r) {
      for (var t = 0, n = this.getStores(r); t < n.length; t++) {
        var a = n[t];
        a.remove(e);
      }
    }, o;
  }()
);
function E(o) {
  return {
    cookie: _.available() ? new _(o) : void 0,
    localStorage: O.available() ? new O() : void 0,
    memory: new K()
  };
}
var N = (
  /** @class */
  function() {
    function o(e, r) {
      e === void 0 && (e = f);
      var t = this, n, a, s, v;
      this.options = {}, this.id = function(i) {
        if (t.options.disable)
          return null;
        var l = t.identityStore.getAndSync(t.idKey);
        if (i !== void 0) {
          t.identityStore.set(t.idKey, i);
          var y = i !== l && l !== null && i !== null;
          y && t.anonymousId(null);
        }
        var p = t.identityStore.getAndSync(t.idKey);
        if (p)
          return p;
        var h = t.legacyUserStore.get(f.cookie.oldKey);
        return h ? typeof h == "object" ? h.id : h : null;
      }, this.anonymousId = function(i) {
        var l, y;
        if (t.options.disable)
          return null;
        if (i === void 0) {
          var p = (l = t.identityStore.getAndSync(t.anonKey)) !== null && l !== void 0 ? l : (y = t.legacySIO()) === null || y === void 0 ? void 0 : y[0];
          if (p)
            return p;
        }
        return i === null ? (t.identityStore.set(t.anonKey, null), t.identityStore.getAndSync(t.anonKey)) : (t.identityStore.set(t.anonKey, i ?? U()), t.identityStore.getAndSync(t.anonKey));
      }, this.traits = function(i) {
        var l;
        if (!t.options.disable)
          return i === null && (i = {}), i && t.traitsStore.set(t.traitsKey, i ?? {}), (l = t.traitsStore.get(t.traitsKey)) !== null && l !== void 0 ? l : {};
      }, this.options = e, this.cookieOptions = r, this.idKey = (a = (n = e.cookie) === null || n === void 0 ? void 0 : n.key) !== null && a !== void 0 ? a : f.cookie.key, this.traitsKey = (v = (s = e.localStorage) === null || s === void 0 ? void 0 : s.key) !== null && v !== void 0 ? v : f.localStorage.key, this.anonKey = "ajs_anonymous_id";
      var I = e.disable === !0, w = e.persist !== !1, d = I ? [] : w ? ["localStorage", "cookie", "memory"] : ["memory"], S = E(r);
      e.localStorageFallbackDisabled && (d = d.filter(function(i) {
        return i !== "localStorage";
      })), this.identityStore = new b(d, S), this.legacyUserStore = new b(d.filter(function(i) {
        return i !== "localStorage" && i !== "memory";
      }), S), this.traitsStore = new b(d.filter(function(i) {
        return i !== "cookie";
      }), S);
      var c = this.legacyUserStore.get(f.cookie.oldKey);
      c && typeof c == "object" && (c.id && this.id(c.id), c.traits && this.traits(c.traits)), j(this);
    }
    return o.prototype.legacySIO = function() {
      var e = this.legacyUserStore.get("_sio");
      if (!e)
        return null;
      var r = e.split("----"), t = r[0], n = r[1];
      return [t, n];
    }, o.prototype.identify = function(e, r) {
      if (!this.options.disable) {
        r = r ?? {};
        var t = this.id();
        (t === null || t === e) && (r = g(g({}, this.traits()), r)), e && this.id(e), this.traits(r);
      }
    }, o.prototype.logout = function() {
      this.anonymousId(null), this.id(null), this.traits({});
    }, o.prototype.reset = function() {
      this.logout(), this.identityStore.clear(this.idKey), this.identityStore.clear(this.anonKey), this.traitsStore.clear(this.traitsKey);
    }, o.prototype.load = function() {
      return new o(this.options, this.cookieOptions);
    }, o.prototype.save = function() {
      return !0;
    }, o.defaults = f, o;
  }()
), P = {
  persist: !0,
  cookie: {
    key: "ajs_group_id"
  },
  localStorage: {
    key: "ajs_group_properties"
  }
}, F = (
  /** @class */
  function(o) {
    k(e, o);
    function e(r, t) {
      r === void 0 && (r = P);
      var n = o.call(this, r, t) || this;
      return n.anonymousId = function(a) {
      }, j(n), n;
    }
    return e;
  }(N)
);
export {
  _ as Cookie,
  F as Group,
  O as LocalStorage,
  b as UniversalStorage,
  N as User,
  E as getAvailableStorageOptions
};
//# sourceMappingURL=index17.js.map
